import React, { useState } from 'react';
import IconView from 'common/IconView';
import { Modal, Button} from 'semantic-ui-react';
import './IconEdit.css'

const IconEdit = function(props) {
  const [ show, setShow ] = useState(false);
  const [ offset, setOffset ] = useState(Math.floor(props.icon / 100));
  const allIcons = Array.from({length: 100}, (v, k) => k + offset*100);

  const trigger = <Button size='mini' compact onClick={() => setShow(true)}><IconView icon={props.icon} /></Button>;
  return (
    <Modal open={show} onClose={() => setShow(false)} trigger={trigger}>
      <Modal.Header>Select icon</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <div className='bs-icon-edit-nav'>
            <Button icon='angle double left' onClick={() => setOffset(offset - 1)} />
            <span className='bs-icon-edit-nav-num'>{offset}</span>
            <Button icon='angle double right' onClick={() => setOffset(offset + 1)} />
          </div>
          <div className='bs-icon-edit-list'>
            {allIcons.map(i => <span key={i} onClick={() => { props.onChange(i); setShow(false); }} ><IconView icon={i}/></span>)}
          </div>
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
}


export default IconEdit;
